/** Vocabulário do Canal de Denúncia — espelho de backend/src/types/denuncia.ts. */

export const CATEGORIAS_DE_DENUNCIA = [
  'ASSEDIO_MORAL',
  'ASSEDIO_SEXUAL',
  'DISCRIMINACAO',
  'FRAUDE',
  'SEGURANCA_DO_TRABALHO',
  'OUTRO',
] as const;
export type DenunciaCategoria = (typeof CATEGORIAS_DE_DENUNCIA)[number];

export const ROTULO_CATEGORIA: Record<DenunciaCategoria, string> = {
  ASSEDIO_MORAL: 'Assédio moral',
  ASSEDIO_SEXUAL: 'Assédio sexual',
  DISCRIMINACAO: 'Discriminação',
  FRAUDE: 'Fraude ou corrupção',
  SEGURANCA_DO_TRABALHO: 'Segurança do trabalho',
  OUTRO: 'Outro',
};

export const SITUACOES_DA_DENUNCIA = [
  'RECEBIDA',
  'EM_ANALISE',
  'PROCEDENTE',
  'IMPROCEDENTE',
  'ARQUIVADA',
] as const;
export type DenunciaStatus = (typeof SITUACOES_DA_DENUNCIA)[number];

export const ROTULO_STATUS: Record<DenunciaStatus, string> = {
  RECEBIDA: 'Recebida',
  EM_ANALISE: 'Em análise',
  PROCEDENTE: 'Procedente',
  IMPROCEDENTE: 'Improcedente',
  ARQUIVADA: 'Arquivada',
};

export const COR_DO_STATUS: Record<DenunciaStatus, 'default' | 'info' | 'success' | 'warning' | 'error'> = {
  RECEBIDA: 'info',
  EM_ANALISE: 'warning',
  PROCEDENTE: 'success',
  IMPROCEDENTE: 'default',
  ARQUIVADA: 'default',
};

export const PRIORIDADES_DA_DENUNCIA = ['BAIXA', 'MEDIA', 'ALTA'] as const;
export type DenunciaPrioridade = (typeof PRIORIDADES_DA_DENUNCIA)[number];

export const ROTULO_PRIORIDADE: Record<DenunciaPrioridade, string> = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
};

export interface Denuncia {
  id: number;
  companyId: number;
  protocolo: string;
  categoria: DenunciaCategoria;
  titulo: string;
  descricao: string;
  local: string | null;
  dataDoOcorrido: string | null;
  envolvidos: string | null;
  anonima: boolean;
  relatorNome: string | null;
  relatorEmail: string | null;
  relatorTelefone: string | null;
  status: DenunciaStatus;
  prioridade: DenunciaPrioridade | null;
  responsavelId: number | null;
  actionPlanItemId: number | null;
  recebidaEm: string;
  encerradaEm: string | null;
}

export interface DenunciaAndamento {
  id: number;
  denunciaId: number;
  autorId: number | null;
  origem: 'COMITE' | 'RELATOR' | 'SISTEMA';
  tipo: 'NOTA' | 'STATUS' | 'MENSAGEM' | 'PEDIDO_INFO';
  statusAnterior: DenunciaStatus | null;
  statusNovo: DenunciaStatus | null;
  texto: string | null;
  visivelAoRelator: boolean;
  createdAt: string;
}

export interface DenunciaAnexo {
  id: number;
  denunciaId: number;
  origem: 'RELATOR' | 'COMITE';
  filePath: string;
  originalName: string | null;
  mimeType: string | null;
  fileSize: number | null;
}

export interface DenunciaDetalhe {
  denuncia: Denuncia;
  andamentos: DenunciaAndamento[];
  anexos: DenunciaAnexo[];
}

export interface DenunciaEstatisticas {
  total: number;
  abertas: number;
  porStatus: Record<string, number>;
  porCategoria: { categoria: string; rotulo: string; total: number }[];
}

export interface ConfigDoCanal {
  ativo: boolean;
  token: string | null;
}

export interface DadosDaDenunciaPublica {
  categoria: DenunciaCategoria | '';
  titulo: string;
  descricao: string;
  local: string;
  dataDoOcorrido: string;
  envolvidos: string;
  anonima: boolean;
  relatorNome: string;
  relatorEmail: string;
  relatorTelefone: string;
}

export interface AcompanhamentoDoRelator {
  protocolo: string;
  status: DenunciaStatus;
  categoria: DenunciaCategoria;
  titulo: string;
  recebidaEm: string;
  mensagens: { texto: string | null; origem: string; em: string }[];
}
